<template>
  <v-container>
    <!-- the curtain cards -->
    <card-picker
      :key="key"
      v-model="curtainType"
      :items="curtains"
      :nullable="false"
      :not-available-text="
        $t('components.curtainPicker.noCurtainsAvailableText')
      "
      @onInfoClick="openInformDialog"
    />

    <v-divider class="my-10" />

    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <fabric-picker-card />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <div class="confirmButtonsBlock">
          <v-btn
            class="primary opacity-bg"
            @click="back"
          >
            <v-icon class="white--text pr-5">
              mdi mdi-chevron-left
            </v-icon>
            Previous step
          </v-btn>
          <v-btn
            class="primary"
            :disabled="!curtainType"
            @click="next"
          >
            Next step
            <v-icon class="white--text pl-5">
              mdi mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <information-dialog
      :fabric-details="curtainDetails"
      curtain-picker
      :show-dialog="showCurtainInfoDialog"
      :title-dialog="$t('components.inform.curtainTitle')"
      @closeDialog="closeInformDialog"
    />
  </v-container>
</template>

<script>
import { PRODUCT_DEFAULTS, SPOTLIGHT_ROD, TRACK_RAIL } from '@/constants'

const CardPicker = () => import('@/components/Pickers/CardPicker')
const FabricPickerCard = () => import('@/components/Cards/FabricPickerCard')
const InformationDialog = () => import('@/components/Dialogs/InformationDialog')
import { mapGetters } from 'vuex'
import { requireAssetWithFallback } from '@/utils'

export default {
  name: 'CurtainPicker',
  components: {
    CardPicker,
    FabricPickerCard,
    InformationDialog
  },
  data() {
    return {
      showCurtainInfoDialog: false,
      curtainDetails: {}
    }
  },
  computed: {
    ...mapGetters({
      mainFabric: 'order/getFabric',
      key: 'order/getResetKey'
    }),
    curtains() {
      this.$wait.start('isLoadingUserCurtainTypes')

      const availableCurtainTypes = ['pleatcurtain', 'ringcurtain', 'wavecurtain']
      const fabricCurtainTypes = this.mainFabric.curtain_types
      if (!fabricCurtainTypes) {
        this.$wait.end('isLoadingUserCurtainTypes')
        return []
      }
      const curtains = availableCurtainTypes.map((availableCurtainType) => {
        return {
          value: availableCurtainType,
          title: this.$i18n.t(
            `enums.CurtainType.${availableCurtainType}.label`
          ),
          imgSrc: requireAssetWithFallback(
            `curtain_type/${availableCurtainType}.png`
          )
        }
      })
      this.$wait.end('isLoadingUserCurtainTypes')
      return curtains
    },
    curtainType: {
      async set(curtainType) {
        // clean up curtain and rail rod flow data
        if (this.curtainType !== curtainType) {
          await this.$store.dispatch('order/resetCurtain', true) // keep fabric
          await this.$store.dispatch('order/resetRailRod')
        }
        // set curtain type
        await this.$store.dispatch('order/setCurtainType', curtainType)
        // set rail or rod string based on the new curtain type
        await this.$store.dispatch(
          'order/setRailRod',
          curtainType === 'ringcurtain' ? 'rod' : 'rail'
        )
        await this.$store.dispatch(
          'order/setRailRodType',
          curtainType === 'ringcurtain' ? SPOTLIGHT_ROD : TRACK_RAIL
        )
        await this.$store.dispatch(
          'order/addCurtainParameter',
          PRODUCT_DEFAULTS[this.curtainType]
        )
      },
      get() {
        return this.$store.getters['order/getCurtainType']
      }
    }
  },
  methods: {
    openInformDialog(curtain) {
      this.curtainDetails = {
        name: this.$i18n.t(`enums.CurtainType.${curtain.value}.label`),
        description: this.$i18n.t(
          `enums.CurtainType.${curtain.value}.infoDialogText`
        ),
        rendered_image_details: [curtain.imgSrc]
      }
      this.showCurtainInfoDialog = true
    },
    closeInformDialog() {
      this.showCurtainInfoDialog = false
      this.curtainDetails = {}
    },
    next() {
      this.$emit('pickCurtain', this.curtainType)
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>
